import React from 'react';
import PropTypes from 'prop-types';
import { GridList, GridListTile } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import PhaseStage from './PhaseStage';
import axios from 'axios';
import auth from 'auth/auth';

const FraudTab = ({
  selectedQuery,
  drillEngine,
  selectedValue,
  parentCallback,
  setPhaseParameter,
  phaseIdMap,
  alternatePhaseIdMap
}) => {
  const [columns, setColumns] = React.useState(
    window.innerWidth > 1000 ? 2 : 1
  );
  window.onresize = event => setColumns(window.innerWidth > 1000 ? 2 : 1);
  const [engine2, setEngine2] = React.useState([]);
  const getAssociationEngine = async () => {
    await axios
      .post(
        process.env.REACT_APP_GRAPHQL_URI,
        {
          query: `
            query Get_Engine($id:ID!){
              engine(id:$id){
                phases{
                  id
                  name
                  active
                  description
                  cypherQuery
                }
              }
            }`,
          variables: { id: drillEngine }
        },
        {
          headers: {
            authorization: auth.getIdToken()
              ? `Bearer ${auth.getIdToken()}`
              : ''
          }
        }
      )
      .then(result => {
        setEngine2(result.data.data.engine.phases);
      })
      .catch(error => {
        console.log(error);
      });
  };
  var cachePolicy = 'no-cache';

  const { loading, error, data } = useQuery(selectedQuery, {
    fetchPolicy: cachePolicy,
    variables: { id: selectedValue }
  });

  if (loading) {
    if (drillEngine !== null && drillEngine !== undefined) {
      getAssociationEngine();
    }
    return <div>Loading...</div>;
  }
  if (error) return <div>Error</div>;
  if (data) {
    if (phaseIdMap === null) {
      data.engine.phases.map(phase => {
        phaseIdMap[`"${phase.id}"`] = false;
        if (engine2 !== undefined) {
          alternatePhaseIdMap[
            `"${engine2.find(x => x.name === phase.name)}"`
          ] = false;
        }
      });
    }
    return (
      <GridList cols={columns}>
        {data.engine.phases.map(phase => (
          <GridListTile key={phase.name} style={{ height: 'auto' }}>
            <PhaseStage
              engine={selectedValue}
              selectedPhase={phase}
              alternatePhase={engine2.find(x => x.name === phase.name)}
              parentCallback={parentCallback}
              setPhaseParameter={setPhaseParameter}
              phaseIdMap={phaseIdMap}
              alternatePhaseIdMap={alternatePhaseIdMap}
            />
          </GridListTile>
        ))}
      </GridList>
    );
  }
};

FraudTab.prototypes = {
  className: PropTypes.string
};

export default FraudTab;
